import { FeatureCollection } from 'geojson'
import { Source } from 'ms-map-gl'
import { FC } from 'react'
import { useH3GeojsonData } from '~map-preview/hooks/useH3GeojsonData'

import { HexagonLayer } from '../../Layers/HexagonLayer'
import { useFilteredGeojson } from '../../handlers/useFilteredGeojson'

import { geojsonify } from '~map-preview/utils/geojsonify'

type H3SourceProps = {
  geojson?: FeatureCollection
}

export const H3Source: FC<H3SourceProps> = geojsonify((props) => {
  const { geojson } = props

  const filteredGeojson = useFilteredGeojson(geojson as FeatureCollection)

  const { hexagonGeojson, resolution } = useH3GeojsonData(filteredGeojson)

  if (!hexagonGeojson) return null
  if (!resolution) return null

  return (
    <Source
      id='mapstack-hexagon'
      type='geojson'
      data={hexagonGeojson}
    >
      <HexagonLayer
        geojson={hexagonGeojson as FeatureCollection}
        resolution3D={resolution}
      />
    </Source>
  )
})
